import { z } from "zod";

const ArticleItem = z.object({
	ean: z.string().nullable(),
	article: z.string(),
	quantity: z.number(),
});
const ArticleItems = z.array(ArticleItem);
export type ArticleItem = z.infer<typeof ArticleItem>;
export type ArticleItems = z.infer<typeof ArticleItems>;

const Configuration = z.any().nullable();

const ProductsSchema = z.array(
	z.looseObject({
		ean: z.string().nullable(),
		priceExVat: z.number(),
		priceIncVat: z.number(),
		sku: z.string(),
		vatRate: z.number(),
		name: z.string(),
		packSize: z.string(),
		key: z.string().nullable(),
	}),
);
export type ProductsData = z.infer<typeof ProductsSchema>;

export const InitResponseSchema = z.object({
	data: z.object({
		reseller: z.looseObject({}),
		products: ProductsSchema,
		currency: z.string(),
		culture: z.looseObject({}),
		vat: z.number(),
	}),
});
export type InitResponse = z.infer<typeof InitResponseSchema>;

const OpenSaveResponseSchema = z.object({
	data: z.object({
		id: z.number(),
		application: z.string(),
		name: z.string(),
		articles: ArticleItems,
		configuration: Configuration,
		snapshot: z.string().nullable(),
		slug: z.string(),
	}),
});
export const OpenResponseSchema = OpenSaveResponseSchema;
export type OpenResponse = z.infer<typeof OpenResponseSchema>;

export const SaveRequestSchema = z.object({
	articles: ArticleItems,
	configuration: Configuration,
	snapshot: z.string(),
	name: z.string(),
});
export type SaveRequest = z.infer<typeof SaveRequestSchema>;

export const SaveResponseSchema = OpenSaveResponseSchema;
export type SaveResponse = z.infer<typeof SaveResponseSchema>;

// The PDF endpoint takes the same body as save; `lan` and `countrycode`
// are passed as query params instead (see pdfRequest in endpoints.ts).
export const PdfRequestSchema = SaveRequestSchema;
export type PdfRequest = z.infer<typeof PdfRequestSchema>;

export const PdfResponseSchema = z.object({
	data: z.object({
		design: z.object({
			name: z.string(),
			slug: z.string(),
		}),
		// eslint-disable-next-line camelcase -- matches the API response key
		pdf_url: z.string(),
	}),
});
export type PdfResponse = z.infer<typeof PdfResponseSchema>;

export const EmailRequestSchema = z.object({
	articles: ArticleItems,
	configuration: Configuration,
	snapshot: z.string(),
	name: z.string(),
	email: z.string(),
	message: z.string(),
});
export type EmailRequest = z.infer<typeof EmailRequestSchema>;
export const EmailResponseSchema = z.object({
	data: z.object({
		message: z.string(),
	}),
});
export type EmailResponse = z.infer<typeof EmailResponseSchema>;
